import React from 'react'
import AppointmentCalendar from './appointmentCalendar'

export const createColumns = (self, record) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'siteId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'orderPersonId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '场地名称',
      name: 'name',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          return <div >{record.name || ''}</div>
        }
      }
    },
    {
      title: '场地编号',
      name: 'code',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          return <div >{record.code || ''}</div>
        }
      }
    },
    {
      title: '预约日期',
      name: 'date',
      formItem: {
        type: 'diy',
        diy: AppointmentCalendar,
        siteId: record && record.siteId,
        rules: [{ required: true, message: '请选择预约日期' }]
      }
    },
    {
      title: '预约人',
      formItem: {
        type: 'custom',
        render: (record, form) => {
          return <div >{record.fullName || ''}</div>
        }
      }
    },
    {
      title: '联系电话',
      name: 'orderMobile',
      formItem: {
        style: { maxWidth: 300 },
        rules: [{ required: true, message: '请输入联系电话' }]
      }
    },
    {
      title: '使用类型',
      name: 'useType',
      dict: [
        { code: 0, codeName: '新产品培训' },
        { code: 1, codeName: '实操培训' },
        { code: 2, codeName: '岗位培训' },
        { code: 3, codeName: '区域会议' },
        { code: 4, codeName: '岗位认证' },
        { code: 5, codeName: '其他' },
      ],
      formItem: {
        type: 'select',
        style: { maxWidth: 300 },
        rules: [{ required: true, message: '请选择使用类型' }]
      }
    },
    {
      title: '备注',
      name: 'remark',
      formItem: {
        style: { minHeight: 100 },
        type: 'textarea'
      }
    }
  ]
}